import { Component, OnInit } from '@angular/core';
import { version } from '../../../../environments/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public anio: number;
  public versionCode: string;

  constructor() { this.anio = new Date().getFullYear(); }

  ngOnInit() {
    this.versionCode = version.VERSION_CODE;
  }

}
